import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./user.view";
import Presenter from "./user.presenter";

const initialStates = [
  {
    name: "app.registration.user",
    url: "/usuarios",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 500,
        name: "Usuários",
        state: "app.registration.user"
      },
      authorization: context =>
        context.user.permissions.includes("manage_users")
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/user/index.js